import { useQuery } from '@tanstack/react-query'

import { fetchCampaignResult } from '@/lib/venue/campaignApi'

export function campaignResultQueryKey(venueId: string, campaignId: number) {
  return ['venue', venueId, 'campaign-result', campaignId] as const
}

export function useCampaignResult(venueId: string, campaignId: number) {
  return useQuery({
    queryKey: campaignResultQueryKey(venueId, campaignId),
    queryFn: () => fetchCampaignResult(venueId, campaignId),
    enabled: Number.isFinite(campaignId),
  })
}
